<template>
    <div class="min-max-filter">
        <e-field grouped>
            <e-field expanded>
                <e-input
                    :model-value="modelValue.min"
                    placeholder="Min"
                    @input="handleMinInput"
                />
            </e-field>
            <e-field expanded>
                <e-input
                    :model-value="modelValue.max"
                    placeholder="Max"
                    @input="handleMaxInput"
                />
            </e-field>
        </e-field>
    </div>
</template>

<script>
export default {
    name: 'MinMaxFilterItem',

    props: {
        filter: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: Object,
            default: () => ({ min: '', max: '' }),
        },
        applyFilter: {
            type: Function,
            required: true,
        },
    },

    methods: {
        handleMinInput(event) {
            const updatedValue = { ...this.modelValue, min: event.target.value };
            this.applyFilter(this.filter, updatedValue, event);
        },

        handleMaxInput(event) {
            const updatedValue = { ...this.modelValue, max: event.target.value };
            this.applyFilter(this.filter, updatedValue, event);
        },
    },
};
</script>
